import {
  Pill,
  Container as explorationContainer,
} from '@exploration/shared-components';
import { desktop, system } from '@thrivent/midwest-shared';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

// ---------------------------------------------------------------------------

export const TopSectionStyles = {
  NBRContainerSection: styled.section``,
  TopSection: styled.section`
    padding: 2rem 0 1rem;
    display: flex;
    flex-direction: column;
  `,
  TopContainer: styled(explorationContainer)`
    display: flex;
    flex-direction: column;
  `,
  TopTitle: styled(MDSText.TitleMd)``,
  TopSubtitle: styled(MDSText.BodyRegDefault)`
    margin-top: ${system.lineHeight['xs'].value}rem;
    ${desktop} {
      margin-top: ${system.lineHeight['lg'].value}rem;
    }
  `,
  TopInquiry: styled(MDSText.BodyHeavySm)`
    margin-top: ${system.lineHeight['xl'].value}rem;
  `,
};

export const PillsSectionStyles = {
  PillsSection: styled.section`
    padding-bottom: 0.75rem;
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${(p) => p.theme.midwestColors.borderDefault};
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  `,
  PillsContainer: styled(explorationContainer)`
    margin-top: 0.25rem;
  `,
  Pill: styled(Pill)`
    &.MuiChip-root {
      margin-right: 0.5rem;
      margin-top: 0.5rem;
      padding-top: 1.15rem;
      padding-bottom: 1.15rem;
    }
    .MuiChip-label {
      ${desktop} {
        padding-inline: 1.25rem;
        font-size: 0.875rem;
      }
    }
  `,
};

export const ChangeableSectionStyles = {
  ChangeableSection: styled.section`
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 2rem 0;

    ${desktop} {
      max-width: calc(1200px + 3rem);
      margin-inline: auto;
      flex-direction: row;
      padding: 2rem 0 1rem 0;
    }
  `,
  ChangeableContainer: styled(explorationContainer)`
    margin: 0;
    ${desktop} {
      max-width: 26rem;
    }
  `,
  ChangeableSectionLeft: styled.div`
    padding: 0 0 2rem 0;
    flex-grow: 1;

    ${desktop} {
      max-width: 26rem;
    }
  `,
};
